export default {"src":"/_next/static/media/Incluso Logo-onDark.9bc3250d.svg","height":254,"width":432,"blurWidth":0,"blurHeight":0};